import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { RouterAction, routerActions } from 'react-router-redux'
import * as classnames from 'classnames'

import { LoadingSpinner } from '../components/LoadingSpinner'
import { PasswordChecker } from '../components/PasswordChecker'
import { AppBarContainer } from './CustomAppBar'
import PageTitle from '../components/PageTitle'

import * as Auth from '../services/auth/auth'

import { FormValidator, FieldValidatedValue } from '../utils/validation/FormValidator'
import * as Validators from '../utils/validation/Validators'
import * as StringUtils from '../utils/StringUtils'

import { StoreState } from '../reducers'

import { Strings } from '../localization'
import { ROUTES } from '../constants/routes'
import { FlatButton } from 'material-ui'

import { StickyContainer, Sticky } from 'react-sticky'
import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import { StringResources } from '../localization/StringResources'

import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'

interface ForgotPasswordProps {
  routePush: (location: string) => RouterAction
}

enum FormFields {
  UserEmail = 'userEmail',
  VerificationCode = 'verificationCode',
  Password = 'password',
  ConfirmPassword = 'confirmPassword'
}

interface FormType {
  [FormFields.UserEmail]: FieldValidatedValue
  [FormFields.VerificationCode]: FieldValidatedValue
  [FormFields.Password]: FieldValidatedValue
  [FormFields.ConfirmPassword]: FieldValidatedValue
}

interface ForgotPasswordState {
  form: FormType
  isLoading: boolean
  fieldsError: boolean
  error: boolean
  errorText?: string
  isLoginConfirmed: boolean
  passwordChecked: boolean
}

class ForgotPassword extends React.Component<ForgotPasswordProps, ForgotPasswordState> {

  private formValidator: FormValidator<FormType>

  constructor(props) {
    super(props)
    this.formValidator = this.initForm()
    this.state = {
      form: this.formValidator.values(),
      fieldsError: false,
      isLoading: false,
      error: false,
      errorText: '',
      isLoginConfirmed: false,
      passwordChecked: false
    }
  }

  submit = () => {
    this.formValidator.validate()
    this.setState({
      form: this.formValidator.values(),
      fieldsError: !this.formValidator.isValid(),
      errorText: this.formValidator.getError()
    }, () => {
      if (!this.state.fieldsError && !this.state.isLoginConfirmed) {
        this.setState({
          isLoading: true
        })
        Auth.forgotPassword(this.state.form[FormFields.UserEmail].value.toLowerCase().trim())
          .then(response => {
            this.setState({
              isLoading: false,
              isLoginConfirmed: true
            })
          })
          .catch(error => {
            console.log(error)
            this.setState({
              isLoading: false,
              error: true,
              errorText: error.message ? error.message : error.toString()
            })

          })
      }
    })
  }

  onChange = e => {
    // let lastChar = e.target.value.slice(-1)
    let value = e.target.value.length === 0 && e.target.name === FormFields.VerificationCode ?
      this.state.form[FormFields.VerificationCode].value : e.target.value

    this.formValidator.setState([{
      name: e.target.name,
      value: value
    }])
    this.setState({
      form: this.formValidator.values(),
      fieldsError: !this.formValidator.isValid(),
      errorText: this.formValidator.getError()
    })
  }

  onPasswordCheckerChange = (result: boolean) => {
    this.setState({
      passwordChecked: result
    })
  }

  changePassword = (e) => {
    e.preventDefault()
    this.formValidator.validate()
    this.setState({
      form: this.formValidator.values(),
      fieldsError: !this.formValidator.isValid(),
      errorText: this.formValidator.getError()
    }, () => {
      if (!this.state.fieldsError && this.state.isLoginConfirmed) {
        this.setState({
          isLoading: true
        })
        let userEmail = this.state.form[FormFields.UserEmail].value ? this.state.form[FormFields.UserEmail].value : ''
        let code = this.state.form[FormFields.VerificationCode].value ? this.state.form[FormFields.VerificationCode].value : ''
        let password = this.state.form[FormFields.Password].value ? this.state.form[FormFields.Password].value : ''
        Auth.changePassword(userEmail, code, password)
          .then(() => {
            this.props.routePush(ROUTES.SIGN_IN)
          })
          .catch(error => {
            if (error.code === StringResources.getString(Strings.ForgotPassword.Codes.verificationCodeMismatch) ||
              error.code === StringResources.getString(Strings.ForgotPassword.Codes.verificationCodeExpired)) {
              this.setState({
                isLoading: false,
                error: true,
                errorText: StringResources.getString(Strings.ForgotPassword.Errors.Messages.OldVerificationCode)
              })
            } else {
              this.setState({
                isLoading: false,
                error: true,
                errorText: error.message ? error.message : error.toString()
              })
            }
          })
      }
    })
  }

  render() {
    return (
      <BaseContainer pageName={EventType.FORGOT_PASSWORD}>
        <LoadingSpinner show={this.state.isLoading} />
        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={false}
        />
        <PageTitle text={StringResources.getString(Strings.ForgotPassword.Title)} />
        <PerfectScrollbar className="vertical-scrollbar">
          <div className="tabTitle">
            {!this.state.isLoginConfirmed && <p className="description">{StringResources.getString(Strings.ForgotPassword.SubHeaders.LoginIsNotConfirmedYet)}</p>}
            {this.state.isLoginConfirmed && <p className="description">{StringResources.getString(Strings.ForgotPassword.SubHeaders.LoginConfirmed)}</p>}
          </div>
          <form onSubmit={this.changePassword} className="forgot-password-form">
            {
              !this.state.isLoginConfirmed && (
                <div className={classnames('authContainer', { error: this.state.fieldsError })}>
                  <p>{StringResources.getString(Strings.ForgotPassword.Inputs.Email.label)}</p>
                  <input
                    type="text"
                    name={FormFields.UserEmail}
                    value={this.state.form[FormFields.UserEmail].value}
                    // placeholder={StringResources.getString(Strings.ForgotPassword.Inputs.Email.placeholder)}
                    onChange={this.onChange}
                    className="centeredInput"
                  />
                  {/* <div className="btn updateBtn" onClick={this.submit}>Submit</div> */}
                </div>
              )
            }
            {
              this.state.isLoginConfirmed && (
                <div className="authContainer">
                  <input
                    type="text"
                    name={FormFields.UserEmail}
                    value={this.state.form[FormFields.UserEmail].value}
                    disabled={true}
                  />
                  <input
                    type="number"
                    className={classnames({ error: this.state.form[FormFields.VerificationCode].error })}
                    name={FormFields.VerificationCode}
                    placeholder={StringResources.getString(Strings.ForgotPassword.Inputs.VerificationCode.placeholder)}
                    value={this.state.form[FormFields.VerificationCode].value}
                    onChange={this.onChange}
                  />
                  <input
                    type="password"
                    name={FormFields.Password}
                    placeholder={StringResources.getString(Strings.ForgotPassword.Inputs.Password.placehoder)}
                    value={this.state.form[FormFields.Password].value}
                    onChange={this.onChange}
                  />
                  <input
                    type="password"
                    name={FormFields.ConfirmPassword}
                    placeholder={StringResources.getString(Strings.ForgotPassword.Inputs.PasswordConfirmation.placehoder)}
                    value={this.state.form[FormFields.ConfirmPassword].value}
                    onChange={this.onChange}
                  />

                  <div className="passwordCheckerContainer">
                    <div>
                      <div className="passwordCheckerContainerTitle">
                        {StringResources.getString(Strings.ForgotPassword.PasswordChecker.Header)}
                      </div>
                      <PasswordChecker
                        password={this.state.form[FormFields.Password].value}
                        confirmPassword={this.state.form[FormFields.ConfirmPassword].value}
                        onChange={this.onPasswordCheckerChange}
                      />
                    </div>
                  </div>
                </div>
              )
            }
          </form>
          <div className={StringUtils.isNotEmpty(this.state.errorText) && (this.state.error || this.state.fieldsError) ? 'alert-div' : ''}>
            <div className={classnames('alertMessage', { active: StringUtils.isNotEmpty(this.state.errorText) && (this.state.error || this.state.fieldsError) })}>
              {`${StringResources.getString(Strings.Common.Error)} ${this.state.errorText}`}
            </div>
          </div>
        </PerfectScrollbar>
        <StickyContainer className="sticky-footer" >
          <Sticky>
            {() => (
              <div className="bottom-part hover">
                <FlatButton
                  label={this.state.isLoginConfirmed ?
                    StringResources.getString(Strings.ForgotPassword.Buttons.Confirm.label) :
                    StringResources.getString(Strings.ForgotPassword.Buttons.SendPassword.label)}
                  className={'flatbutton'}
                  onClick={this.state.isLoginConfirmed ? this.changePassword : this.submit}
                />
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </BaseContainer>
    )
  }

  private initForm = () => {
    return new FormValidator<FormType>([
      {
        name: FormFields.UserEmail,
        value: '',
        validator: Validators.email,
        messages: {
          email: StringResources.getString(Strings.ForgotPassword.Errors.Messages.Email)
        }
      },
      {
        name: FormFields.VerificationCode,
        value: '',
        validator: (value) => {
          return this.state.isLoginConfirmed ? Validators.verificationCode(value) : undefined
        },
        messages: {
          vc: StringResources.getString(Strings.ForgotPassword.Errors.Messages.VerificationCode)
        }
      },
      {
        name: FormFields.Password,
        value: '',
        validator: (_) => undefined
      },
      {
        name: FormFields.ConfirmPassword,
        value: '',
        validator: (_) => undefined
      }

    ])
  }

}

function mapStateToProps(state: StoreState) {
  return {}
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(ROUTES.SIGN_IN))
  }
}

export const ForgotPasswordContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.tsx